import { Rect } from "react-konva";
import { calcDashProperties } from "utils/node-utils";

interface OrgChartNodeBackgroundProps {
  width: number;
  height: number;
  strokeColor: string;
  strokeWidth: number;
  dash: number;
  bgProps: {
    stripeColor: string | undefined;
    stripeStart: number;
    stripeEnd: number;
    borderRadius?: number;
  };
}

export default function OrgChartNodeBackground({
  width,
  height,
  strokeColor,
  strokeWidth,
  dash,
  bgProps,
}: OrgChartNodeBackgroundProps) {
  let radius = bgProps.borderRadius || 0;
  let innerRadius = Math.max(0, radius - strokeWidth / 2);

  return (
    <>
      <Rect
        name="orgchart-node-background"
        width={width}
        height={height}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        {...calcDashProperties(strokeWidth, dash)}
        fill="white"
        hitStrokeWidth={0}
        cornerRadius={radius}
      />
      {bgProps.stripeColor && (
        <Rect
          x={strokeWidth / 2}
          y={bgProps.stripeStart}
          width={width - strokeWidth}
          height={bgProps.stripeEnd - bgProps.stripeStart - strokeWidth / 2}
          fill={bgProps.stripeColor}
          cornerRadius={[0, 0, innerRadius, innerRadius]}
        />
      )}
    </>
  );
}
